const GAC_MARCA = "gac";
const GAC_BANNER_NAME_PREFIX = "[GAC] ";
const GAC_TYC_TITLE_PREFIX = "[GAC] ";
const GAC_UPLOAD_DIRS = {
  banners: "imagenes_banners_gac",
};

const stripGacBannerName = (name = "") =>
  String(name).replace(/^\[GAC\]\s*/, "").trim();

const tagGacBannerName = (name = "") => {
  const clean = stripGacBannerName(name);
  return clean ? `${GAC_BANNER_NAME_PREFIX}${clean}` : clean;
};

const stripGacTycTitle = (title = "") =>
  String(title).replace(/^\[GAC\]\s*/, "").trim();

const tagGacTycTitle = (title = "") => {
  const clean = stripGacTycTitle(title);
  return clean ? `${GAC_TYC_TITLE_PREFIX}${clean}` : clean;
};

export {
  GAC_MARCA,
  GAC_BANNER_NAME_PREFIX,
  GAC_TYC_TITLE_PREFIX,
  GAC_UPLOAD_DIRS,
  stripGacBannerName,
  tagGacBannerName,
  stripGacTycTitle,
  tagGacTycTitle,
};
